import { Component } from '@angular/core';

import { TeaserCard } from '../../../models/teaser-card';
import { teaserCards } from '../../../config/teaser-cards';

@Component({
    selector: 'app-home-view',
    templateUrl: './home-view.component.html',
    standalone: false,
})
export class HomeViewComponent {
    public teaserCards: TeaserCard[] = teaserCards;
}
